import React, { useContext, useRef, useEffect } from "react"
import { ContextStore } from "Reducer"
import { useTranslation } from "react-i18next"

export default ({ focusHandler, isFocus }) => {
  const {
    state: { stateReducer },
    dispatch,
  } = useContext(ContextStore)
  const searchValue = stateReducer.get("searchValue")
  const { t } = useTranslation()
  const inputRef = useRef()
  const inputHandler = (value) => {
    dispatch({ type: "CHANGE_DATA", path: "searchValue", value })
  }

  useEffect(() => {
    const ref = inputRef.current
    if (isFocus && ref) {
      ref.focus()
    }
  }, [isFocus])

  return (
    <input
      ref={inputRef}
      className={`gav2_btn_search`}
      placeholder={t("searchGame")}
      value={searchValue}
      onChange={(e) => inputHandler(e.target.value)}
      onFocus={() => {
        focusHandler(true)
      }}
      onBlur={() => {
        !searchValue && focusHandler(false)
      }}
    />
  )
}
